<template>
  <Main>
    <BaseTab :value="currentTab" @change="currentTab = $event">
      <v-tab v-if="enableImport">Importar</v-tab>
      <v-tab-item v-if="enableImport" class="py-5">
        <LegacyImportationForm @changeTab="changeCurrentTab" />
      </v-tab-item>
      <v-tab v-if="enableList">Logs de importação</v-tab>
      <v-tab-item v-if="enableList" class="py-5">
        <LegacyImportationTable
          :current-tab="currentTab"
          :number-legacy="numberLegacy"
        />
      </v-tab-item>
    </BaseTab>
  </Main>
</template>
<script>
import LegacyImportationForm from "../components/LegacyImportationForm";
import LegacyImportationTable from "../components/LegacyImportationTable";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  name: "LegacyImportationList",
  mixins: [LoadingRequest],
  components: { LegacyImportationForm, LegacyImportationTable },
  data: () => ({
    currentTab: 0,
    idList: "consultar_legado",
    idImport: "importar_legado",
    numberLegacy: ""
  }),
  created() {
    Promise.all([
      this.fetchItemsStatusLegacyImportation(),
      this.fetchItemsTypeLegacyImportation()
    ]);
  },
  computed: {
    ...mapState(["userPermissions"]),
    enableImport() {
      return this.permissionById(this.idImport);
    },
    enableList() {
      return this.permissionById(this.idList);
    }
  },
  methods: {
    ...mapActions("legacy_importation", [
      "requestItemsTypeLegacyImportation",
      "requestItemsStatusLegacyImportation"
    ]),
    ...mapActions(["showAlertNotification"]),
    fetchItemsStatusLegacyImportation() {
      this.withLoading(this.requestItemsStatusLegacyImportation());
    },
    fetchItemsTypeLegacyImportation() {
      this.withLoading(this.requestItemsTypeLegacyImportation());
    },
    permissionById(id) {
      return this.userPermissions.acoes.find(x => x.id === id);
    },
    changeCurrentTab(value) {
      if (this.enableList) {
        this.currentTab = 1;
        this.numberLegacy = value;
      }
    }
  }
};
</script>
